import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Card, Avatar, Input, Popconfirm, Image, Col, Row, message, Table, Checkbox, Tab, Carousel } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { DeleteOutlined, EditOutlined, UserOutlined, MoreOutlined, HistoryOutlined } from '@ant-design/icons';
import Carousel_news_ticker from "../Carousel_news_ticker";
import PreviewImgModal from "./PreviewImgModal";
import PreviewVideoModal from "./PreviewVideoModal";
import PreviewModal from "./PreviewModal";
import PreviewPdfModal from "./PreviewPdfModal";
import PreviewWordModal from "./PreviewWordModal";
import PreviewMp3Modal from "./PreviewMp3Modal";
import PreviewPPTModal from "./PreviewPPTModal";
const { Search } = Input;
const MediaCard = (
    {
        topic = 'card',
        deleterow = true,
        span = 6,
        edit = true,
        data,
        setData = () => { },
        xxl = 6,
        xl = 6,
        lg = 6,
        md = 6,
        sm = 12,
        xs = 24,
        handleEdit = () => { },
        handleDeleteRow = () => { },
        loading = false,
        setLoading = () => { },
    }
) => {
    const [dataTmp, setDataTmp] = useState([])
    const [hover, setHover] = useState(null);
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const [messageApi, contextHolder] = message.useMessage();
    const [modal_mp3, set_modal_mp3] = useState(false);
    const [content, setContent] = useState('')
    const [modal_word, set_modal_word] = useState(false);
    const [modal_pdf, set_modal_pdf] = useState(false);
    const [modal_ppt, set_modal_ppt] = useState(false);
    const [type, set_type] = useState(null);
    const [modal_file, set_modal_file] = useState(false)
    const [modal_img, set_modal_img] = useState(false);
    const [url, setUrl] = useState('');
    const [dataurl, setDataUrl] = useState('');
    const [file, set_file] = useState();
    const [modal_video, set_modal_video] = useState(false);
    const handlePreview = (file_type, type, item) => {
        set_file(item);
        setUrl(null);
        // console.log(type);
        if (file_type === 'pic') {
            axios
                .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": item.file_id } })
                .then((response) => {
                    var blob_ = new Blob([response.data], {
                        type: "image/jpg",// this is the only MIME for SVG

                    });
                    const dataurl = URL.createObjectURL(blob_);
                    setUrl(dataurl);
                    // console.log(item.file_url);
                    set_modal_img(true);
                })
        } else {
            if (file_type != 'video') {
                axios
                    .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": item.file_id } })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/png",// this is the only MIME for SVG
                        });
                        // console.log(blob_);
                        var reader = new FileReader();
                        reader.readAsDataURL(blob_);
                        reader.onloadend = function () {
                            var base64String = reader.result;
                            // console.log(base64String);
                            setUrl(base64String);
                        }
                        const dataurl = URL.createObjectURL(blob_);
                        setDataUrl(dataurl);
                    })
            }
            if (file_type === 'video') {
                var videodataurl = '';
                // axios
                //     .get('/media/api/classify_structure_type_file_video', {
                //         responseType: 'blob',
                //         params: {
                //             file_id: item.file_id
                //         }
                //     })
                //     .then((response) => {
                //         videodataurl = window.URL.createObjectURL(new Blob([response.data]));
                //     })
                // console.log(videodataurl);
                videodataurl = `${axios.defaults.baseURL}/media/api/classify_structure_type_file_video?file_id=${item["file_id"]}`;
                setDataUrl(videodataurl)
                set_modal_video(true);
            } else if (type == 'xlsx' || type == 'xls') {
                set_type(type);
                setLoading(true)
                // console.log(loading)
                setTimeout(() => {
                    set_modal_file(true);
                }, [2000])
                setLoading(false)
            } else if (type == 'pdf') {
                set_modal_pdf(true);
            } else if (type == 'docx' || type == 'doc') {
                getWord(item.file_id);
                set_modal_word(true);
            } else if (file_type == 'audio') {
                set_modal_mp3(true)
            } else {
                set_modal_ppt(true);
            }

        }
    }
    const getWord = (file_id) => {
        axios
            .get('/cramSchool/api/file/docx', { params: { file_id: file_id } })
            .then((response) => {
                setContent(response.data.content)
            })
    }
    const handleEditWord = (file_id) => {
        axios
            .post('/cramSchool/api/file/docx', { content: content, file_id: file_id })
            .then((response) => {
                if (response.data.status == 'failure') {
                    messageApi.open({
                        type: 'error',
                        // content: label_language.Common.children.edit_error[language],
                        content: '修改失敗',
                    });
                } else {
                    messageApi.open({
                        type: 'success',
                        // content: label_language.Common.children.edit_success[language],
                        content: '修改成功',
                    });
                }
                set_modal_word(false)
            })
    }
    const handleDelete = (file_id) => {
        // console.log(file_id);
        console.log(data.filter(filter_item => filter_item.file_id !== file_id))
        setData(prev => prev.filter(filter_item => filter_item.file_id !== file_id));
    }
    return (
        <>
            {contextHolder}
            <PreviewMp3Modal
                open={modal_mp3}
                setOpen={set_modal_mp3}
                file={file}
                file_url={dataurl}
            />
            <PreviewWordModal
                open={modal_word}
                setOpen={set_modal_word}
                file={file}
                file_url={url}
                content={content}
                setContent={setContent}
                handleEdit={handleEditWord}
            />
            <PreviewPdfModal
                open={modal_pdf}
                setOpen={set_modal_pdf}
                file={file}
                file_url={url}
            />
            <PreviewModal
                open={modal_file}
                setOpen={set_modal_file}
                type={type}
                file={file}
                file_url={url} />
            <PreviewImgModal
                download={true}
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                file={file}
                img={url}
            ></PreviewImgModal>
            <PreviewVideoModal
                open={modal_video}
                setOpen={set_modal_video}
                file={file}
                file_url={dataurl}
            />
            <PreviewPPTModal
                open={modal_ppt}
                setOpen={set_modal_ppt}
                file={file}
                file_url={url}
            />
            {/* <Row gutter={[8, 8]}> */}
            {data && data.map((item, i) => {
                let str = (item['file_client_name'] || "").split('.');
                let file_extension_tmp = `${str.at(-1)}`;
                return (
                    <Col sm={{ span: 24 }} md={{ span: span }} justify='center' style={{ position: 'relative', minWidth: dimensions['width'] < 500 ? '100%' : 'auto' }}>
                        <Row gutter={[8, 8]}>
                            <Col span={24} style={{ position: 'relative' }}>
                                <Col style={{ position: 'absolute', left: '-10px', top: '-10px', zIndex: 99 }}>
                                    <Avatar icon={<UserOutlined />} />
                                </Col>
                                <Card
                                    bodyStyle={{ padding: '10px' }}
                                    bordered
                                >
                                    <Row justify={'center'} onClick={e => handlePreview(item.file_type, file_extension_tmp, item)} style={{ cursor: 'pointer' }}>
                                        <Col span={22}>
                                            <Image width={'100%'} height={'100%'} src={item.dataurl} preview={false} />
                                        </Col>
                                    </Row>
                                    {edit ? <>
                                        <Col className='example' style={{ position: 'absolute', top: 0, right: 0 }}>
                                            <EditOutlined
                                                className='example'
                                                style={{
                                                    backgroundColor: '#F9D4E5',
                                                    fontSize: '1rem',
                                                    borderRadius: '50%',
                                                    padding: '8px'
                                                }}
                                                onClick={e => { handleEdit(item.file_type, item.file_id, item) }}
                                            />
                                        </Col>
                                    </> : null}
                                    {deleterow ? <>
                                        <Col className='example' style={{ position: 'absolute', top: 0, right: 0 }}>
                                            <DeleteOutlined
                                                className='example'
                                                style={{
                                                    backgroundColor: '#F9D4E5',
                                                    fontSize: '1rem',
                                                    borderRadius: '50%',
                                                    padding: '8px'
                                                }}
                                                onClick={e => { handleDelete(item.file_id) }}
                                            />
                                        </Col>
                                    </> : null}
                                    <Row gutter={24} align={'middle'} justify={'center'}>
                                        <Col span={24} style={{ color: '#888888', fontSize: '1em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' }}>
                                            {item.file_client_name}
                                        </Col>

                                        <Col span={24} style={{ color: '#888888', fontSize: '1em', textAlign: 'left' }}>
                                            上傳人：{item.upload_user_name}
                                        </Col>
                                        <Col span={24} style={{ color: '#888888', fontSize: '1em', textAlign: 'left' }}>
                                            {item.upload_time}
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    // </Row>
                    // </Col >
                )
            })}
        </>
    )
}
export default MediaCard;